var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "treatments-and-date" },
    [
      _vm.shouldShowMastheadAndTitle
        ? _c("div", { staticClass: "treatments-and-date__header" }, [
            _c(
              "a",
              {
                staticClass: "treatments-and-date__back-cta",
                attrs: {
                  href: "/" + _vm.lang + _vm.propertyData.detailsPageUrl,
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.tc("spaSoft.step1.backToSpaCta")) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("h2", { staticClass: "treatments-and-date__title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.tc("spaSoft.step1.guestTimeDateSelection.title")) +
                  "\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.itineraryErrors
        ? _c(
            "div",
            {
              staticClass: "treatments-and-date__error-banner",
              attrs: { role: "alert" },
            },
            [
              _c("span", {
                staticClass: "icon-warning-red",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "treatments-and-date__error-banner-list" },
                _vm._l(_vm.itineraryErrorsMessages, function (error, index) {
                  return _c("li", {
                    key: index,
                    domProps: { innerHTML: _vm._s(error.errorMessage) },
                  })
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("SpaBookingDetailsForm"),
      _vm._v(" "),
      _c("hr", { staticClass: "spacer" }),
      _vm._v(" "),
      _vm._l(_vm.guestsSelectedData, function (guest, key) {
        return _c("GuestTreatmentSelector", {
          key: key,
          attrs: { "guest-data": guest, "guest-key": Number(key) },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }